import { render, staticRenderFns } from "./PrintingModelLayout.vue?vue&type=template&id=98b28dd0&scoped=true"
import script from "./PrintingModelLayout.vue?vue&type=script&lang=js"
export * from "./PrintingModelLayout.vue?vue&type=script&lang=js"
import style0 from "./PrintingModelLayout.vue?vue&type=style&index=0&id=98b28dd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b28dd0",
  null
  
)

export default component.exports